<template>
    <Card :bordered="false" class="border-radius-0">
        <Form layout="horizontal">
            <CardBorder :title="$t('lab.labProductGroup')">
                <TemplateBuilder
                        v-if="data.fields"
                        :fields="data.fields"
                        :useForm="data.useForm"
                ></TemplateBuilder>
            </CardBorder>
        </Form>
    </Card>
</template>

<script>
    import { defineAsyncComponent, defineComponent } from "vue";
    import { Card, Form } from "ant-design-vue";

    export default defineComponent({
        components: {
            Card,
            Form,
            CardBorder: defineAsyncComponent(() => import("../../../../../components/card/CardBorder")),
            TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder"))
        },
        props: {
            form: {},
            data: {},
        },
        setup(props) {
            return {
                props,
            };
        }
    });
</script>
